import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAdministrators', 'administrators'),
  ...generateMutations('saveAdministrator', 'administrator'),
  ...generateMutations('getAdministrator', 'administrator'),
  ...generateMutations('deleteAdministrator'),
}
